import http from "@/axios/http-common";
import ErrorAlert from "@/utility/ErrorAlert";

export interface KegiatanKlinikIgdPeriode {
  tahun: number;
  bulan: number;
  label: string;
  nama_bulan: string;
}

export interface KegiatanKlinikIgdMeta {
  total_kunjungan: number;
  tanpa_disposisi: number;
  tanpa_gender: number;
}

export interface KegiatanKlinikIgdResponse {
  periode: KegiatanKlinikIgdPeriode;
  kategori: Record<string, string>;
  kolom: Record<string, string>;
  kolom_total_pasien: string[];
  kolom_tidak_lanjut: string[];
  gender: Record<string, string>;
  rme: Record<string, number>;
  koreksi: Record<string, number>;
  nilai: Record<string, number>;
  ket: Record<string, string>;
  meta: KegiatanKlinikIgdMeta;
}

export interface PeriodeParam {
  tahun: number;
  bulan: number;
}

export function selKey(
  kategori: string,
  kolom: string,
  gender: string
): string {
  return `rekap.${kategori}.${kolom}.${gender}`;
}

export function ketKey(kategori: string): string {
  return `rekap.ket.${kategori}`;
}

async function get(p: PeriodeParam): Promise<KegiatanKlinikIgdResponse> {
  const res = await http
    .getDataParam(`/laporan/kegiatan-klinik-igd`, { params: p })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data.data;
}

async function save(
  p: PeriodeParam,
  koreksi: Record<string, number | string>
): Promise<KegiatanKlinikIgdResponse> {
  const res = await http
    .putData(`/laporan/kegiatan-klinik-igd`, { ...p, koreksi })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  return res.data.data;
}

async function openPdf(p: PeriodeParam): Promise<void> {
  const res = await http
    .getDataParam(`/laporan/kegiatan-klinik-igd/pdf`, {
      params: p,
      responseType: "blob"
    })
    .catch(err => {
      ErrorAlert.showErrorAlert(err);
      return Promise.reject(err);
    });

  const url = URL.createObjectURL(
    new Blob([res.data], { type: "application/pdf" })
  );
  window.open(url, "_blank");
  setTimeout(() => URL.revokeObjectURL(url), 60000);
}

export default { get, save, openPdf, selKey, ketKey };
